import { getUniversalHelpers } from "../../helpers";

export async function message__client__get(p: { messageId: string }) {
  const { ollieFirestoreV2: h } = getUniversalHelpers();

  return h.Message.getDoc(p.messageId);
}

// i18n certified - complete
